import { render, staticRenderFns } from "./ListWallets.vue?vue&type=template&id=79b0c5ec"
import script from "./ListWallets.vue?vue&type=script&lang=js"
export * from "./ListWallets.vue?vue&type=script&lang=js"
import style0 from "./ListWallets.vue?vue&type=style&index=0&id=79b0c5ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports